// settings-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'set.msg.saved.settings': 'Settings saved',
  'set.msg.saved.business': 'Business saved',
  'set.msg.saved.accounting': 'Accounting saved',
  'set.msg.saved.startup': 'Starting figures saved',
  'set.msg.saved.openingBalance': 'Opening balance saved',
  'set.msg.saved.bank': 'Bank saved',
  'set.msg.saved.import': 'Import saved',
  'set.msg.saved.productImport': 'Product import saved',
  'set.msg.saved.generic': '{label} saved',
  'set.msg.settingsNotConnected': 'Settings are not connected to the backend.',
  'set.msg.settingsSaveFailed': 'Could not save settings.',
  'set.msg.backendActionNotConnected': 'The backend is not connected to this action.',
  'set.msg.saveFailed': 'Could not save.',
  'set.msg.businessNotFound': 'Could not find the business.',
  'set.msg.profileSaved': 'User profile saved',
  'set.msg.profileSaveFailed': 'Could not save the user profile.',
  'set.msg.invitesNotConnected': 'Invitations are not connected to the backend in this build.',
  'set.msg.inviteCreatedEmailFailed': 'The invitation was created, but the email could not be sent.',
  'set.msg.inviteSent': 'Invitation sent by email',
  'set.msg.inviteSendFailed': 'Could not send the invitation.',
  'set.msg.ownershipNotConnected': 'Ownership transfer is not connected to the backend in this build.',
  'set.msg.ownershipConfirm': 'Send an ownership transfer invitation? The new user becomes the owner when the invitation is accepted.',
  'set.msg.ownershipCreatedEmailFailed': 'The ownership transfer was created, but the email could not be sent.',
  'set.msg.ownershipInviteSent': 'Ownership transfer invitation sent by email',
  'set.msg.ownershipSendFailed': 'Could not send the ownership transfer.',
  'set.msg.removeAccessNotConnected': 'Removing access is not connected to the backend.',
  'set.msg.thisUser': 'this user',
  'set.msg.removeAccessConfirm': 'Remove access for {email}? The user will lose access to the selected business.',
  'set.msg.accessRemoved': 'Access removed',
  'set.msg.removeAccessFailed': 'Could not remove access.',
  'set.msg.leaveNotConnected': 'Leaving a business is not connected to the backend.',
  'set.msg.leaveConfirm': 'Remove your access to {businessName}? You will need to be invited again to regain access.',
  'set.msg.leftBusiness': 'You have left the business',
  'set.msg.leaveFailed': 'Could not remove your access.',
  'set.msg.inviteAccepted': 'Invitation accepted',
  'set.msg.verifyEmailFirst': 'Confirm your email address first. We have sent you a new link.',
  'set.msg.inviteAcceptFailed': 'Could not accept the invitation.',
  'set.msg.preferencesNotConnected': 'Preferences are not connected to the backend.',
  'set.msg.preferencesSaveFailed': 'Could not save preferences.',
  'set.msg.documentUploadNotConnected': 'Document upload is not connected to the backend.',
  'set.msg.documentSaved': 'Document saved',
  'set.msg.documentUploadFailed': 'Could not upload the document.',
  'set.msg.accountNumberAndName': 'Enter an account number and name.',
  'set.msg.pickStandardAccount': 'Select the corresponding standard account.',
  'set.msg.accountNumberExists': 'The account number already exists.',
  'set.msg.accountNameRequired': 'Enter an account name.',
  'set.msg.accountAlreadyDeactivated': 'The account is already deactivated and is kept in the history.',
  'set.msg.usedIn': ' It is used in {labels}.',
  'set.msg.customAccountDeactivateConfirm': '{name} has history.{details}\n\nDeactivate the account instead? It is hidden from new vouchers and account choices, but kept in reports, SAF-T and old vouchers.',
  'set.msg.deleteAccountConfirm': 'Delete {name}? The account is not used in the history.',
  'set.msg.pickOtherInvoiceAccount': 'Select another invoice account before you can delete or deactivate this one.',
  'set.msg.bankAccountFallback': 'The bank account',
  'set.msg.bankAccountDeactivateConfirm': '{name} has history.{details}\n\nDeactivate the account instead? It is hidden from new payments and bank choices, but kept in old vouchers and reports.',
  'set.msg.partyIoNotLoaded': 'Import/export of register data is not loaded.',
  'set.msg.supplierListDownloaded': 'Supplier list downloaded',
  'set.msg.customerListDownloaded': 'Customer list downloaded',
  'set.msg.partyExportFailed': 'Could not export the register.',
  'set.msg.productExportNotLoaded': 'Product export is not loaded.',
  'set.msg.productListDownloaded': 'Product list downloaded',
  'set.msg.productExportFailed': 'Could not export the product list.',
  'set.msg.invoiceExportNotLoaded': 'Detailed invoice export is not loaded.',
  'set.msg.invoiceLinesExported': '{count} invoice lines exported',
  'set.msg.invoiceExportFailed': 'Could not export invoices.',
  'set.msg.completeExportNotConnected': 'Complete export is not yet connected to the backend.',
  'set.msg.exportPackageNoLink': 'The export package was built but has no download link.',
  'set.msg.completeExportReady': 'Complete export ready: {files} original files and {years} fiscal years.',
  'set.msg.completeExportFailed': 'Could not build the complete export.',
  'set.msg.invoiceTemplateNotLoaded': 'The invoice import template is not loaded.',
  'set.msg.invoiceTemplateDownloaded': 'Invoice import template downloaded',
  'set.msg.invoiceTemplateExportFailed': 'Could not export the invoice import template.',
  'set.msg.partyImportNotLoaded': 'Import of register data is not loaded.',
  'set.msg.noValidRows': 'No valid rows were found in the file.',
  'set.msg.supplierImportNotConnected': 'Supplier import is not connected to the backend.',
  'set.msg.customerImportNotConnected': 'Customer import is not connected to the backend.',
  'set.msg.suppliersImported': '{count} suppliers imported',
  'set.msg.customersImported': '{count} customers imported',
  'set.msg.partyImportFailed': 'Could not import the register.',
  'set.msg.productImportNotLoaded': 'Product import is not loaded.',
  'set.msg.noProductsInFile': 'No products were found in the file.',
  'set.msg.productsImported': '{count} products imported',
  'set.msg.productImportFailed': 'Could not import products. Use a CSV or XLSX file based on the Plumme product template.',
  'set.msg.invoiceImportNotLoaded': 'Invoice import is not loaded.',
  'set.msg.invoiceImportNotConnected': 'Invoice import is not connected to the backend.',
  'set.msg.noValidInvoiceRows': 'No valid invoice rows were found in the file.',
  'set.msg.invoiceImportOver500Confirm': 'The file contains more than 500 invoices. Continue the import as drafts?',
  'set.msg.invoicesImportedAsDraft': '{count} invoices imported as drafts',
  'set.msg.invoiceImportDuplicateExisting': 'The file contains invoice numbers that already exist.',
  'set.msg.invoiceImportDuplicateFile': 'The file contains the same invoice number several times on different invoices.',
  'set.msg.invoiceImportFailed': 'Could not import invoices.',
  'set.msg.jsonMissingState': 'The file is missing app state.',
  'set.msg.jsonImportFailed': 'Could not import JSON.',
  'set.msg.voucherExportNotLoaded': 'Voucher export is not loaded.',
  'set.msg.vouchersExported': '{count} vouchers exported',
  'set.msg.postingLinesExported': '{count} posting lines exported',
  'set.msg.voucherExportFailed': 'Could not export voucher data.',
  'set.msg.completeImportNotConnected': 'Complete accounting import is not yet connected to the backend.',
  'set.msg.importFilesCount': '{count} import files',
  'set.msg.importAnalysisDone': 'The import analysis is complete.',
  'set.msg.importAnalyzed': 'Import analyzed: {files} files, {saft} SAF-T, {excel} Excel and {csv} CSV.',
  'set.msg.importAnalyzeFailed': 'Could not analyze the complete accounting export.',
  'set.msg.runAnalysisFirst': 'Run the import analysis first.',
  'set.msg.analysisMissingFiles': 'The latest analysis has no stored import files. Upload the files again.',
  'set.msg.reanalyzeNotConnected': 'Re-analysis of the complete import is not yet connected to the backend.',
  'set.msg.reanalyzingSameSet': 'Re-analyzing the same uploaded file set.',
  'set.msg.analysisUpdated': 'The import analysis has been updated from the same file set.',
  'set.msg.importReanalyzed': 'Import re-analyzed: {files} files, {saft} SAF-T, {excel} Excel and {csv} CSV.',
  'set.msg.reanalyzeFailed': 'Could not re-analyze the complete accounting export.',
  'set.msg.approveNotConnected': 'Approval of the complete import is not yet connected to the backend.',
  'set.msg.baseDataImported': 'Base data has been imported.',
  'set.msg.baseDataImportedCheck': 'Base data has been imported. Check the opening balance before reporting.',
  'set.msg.approveFailed': 'Could not approve the import.',
  'set.msg.saftExportNotConnected': 'SAF-T export is not connected to the backend.',
  'set.msg.saftExported': 'SAF-T XML exported with {count} vouchers',
  'set.msg.saftExportFailed': 'Could not export SAF-T XML.',
  'set.msg.saftAnalyzeFailed': 'The SAF-T file could not be analyzed. Check that this is a valid SAF-T Financial XML file.',
  'set.msg.bulkDeleteNotConnected': 'Bulk deletion is not connected to the backend.',
  'set.msg.bulkDeleted': '{count} {label} deleted',
  'set.msg.bulkDeleteFailed': 'Could not delete {label}.',
  'set.msg.fullResetNotConnected': 'Full reset is not connected to the backend.',
  'set.msg.resetCleanupFailed': 'The data was reset, but cleanup of some files or archives failed. Try again or contact support.',
  'set.msg.mailboxFetched': 'Voucher inbox fetched from the backend',
  'set.msg.mailboxFetchFailed': 'Could not fetch the voucher inbox.',
  'set.msg.mailboxRotateConfirm': 'Generate a new voucher inbox address? The previous address will stop working.',
  'set.msg.mailboxRotated': 'New voucher inbox address generated',
  'set.msg.mailboxRotateFailed': 'Could not rotate the voucher inbox.',
  'set.msg.mailboxCreatedByBackend': 'Created by the backend when the voucher inbox is activated',
  'set.msg.logoTooLarge': 'The logo can be at most 1 MB.',
  'set.msg.logoTypeInvalid': 'Choose PNG, JPG or WebP as the company logo.',
  'set.msg.logoReadFailed': 'Could not read the logo.',
  'set.msg.logoSaved': 'Logo saved in Firebase Storage',
  'set.msg.logoSaveFailed': 'Could not save the logo.',
  'set.msg.logoDeleteConfirm': 'Delete the company logo?',
  'set.msg.logoDeleted': 'Logo deleted',
  'set.msg.logoDeleteFailed': 'Could not delete the logo.',
  'set.msg.portalOpenFailed': 'Could not open the customer portal.',
  'set.msg.checkoutFailed': 'Could not start the payment.',
  'set.msg.businessScheduledForDeletion': 'The business is scheduled for deletion.',
  'set.msg.deletionRegistered': 'The deletion has been registered.',
  'set.msg.deletionScheduleFailed': 'Could not schedule the deletion.',
  'set.msg.clientSwitchNotConnected': 'Switching client is not connected to the backend.',
  'set.msg.switchedTo': 'Switched to {name}',
  'set.msg.switchBusinessFailed': 'Could not switch business.',
  'set.msg.cancelInviteNotConnected': 'Withdrawing an invitation is not connected to the backend.',
  'set.msg.cancelInviteConfirm': 'Withdraw the invitation to {email}?',
  'set.msg.inviteCancelled': 'Invitation withdrawn',
  'set.msg.inviteCancelFailed': 'Could not withdraw the invitation.',
  'set.msg.inviteResent': 'The invitation has been added to the sending queue',
  'set.msg.inviteResendFailed': 'Could not resend the invitation.',
  'set.msg.accessUpdatedLive': 'Access is updated continuously via the backend.',
});
